import styled from 'styled-components'

// Utils
import { hexToRGB } from 'lib/utils'

interface Props {
  open: boolean
  variant?: string
  invisible?: boolean
  relative?: boolean
}

// console.info((props) => props.invisible)
export const BlockUI = styled.section<Props>`
  position: ${(props) => (props.relative ? 'absolute' : 'fixed')};
  top: 0;
  left: 0;
  display: grid;
  place-items: center;
  width: ${(props) => (props.relative ? '100%' : '100vw')};
  height: ${(props) => (props.relative ? '100%' : '100vh')};
  background-color: ${hexToRGB('#ffffff', 0.8)};
  opacity: 0;
  pointer-events: none;
  visibility: ${(props) => (props.invisible ? 'true' : 'false')};
  z-index: 100000;
  transition: all 1s;
  transition-delay: 2050ms;

  ${({ open, invisible }) =>
    open &&
    `
      opacity: ${!invisible ? '1' : '0'};
      pointer-events: auto;
  `};
`
